import { useMutation, type MutationFunctionContext, type UseMutateAsyncFunction } from "@tanstack/react-query";
import { createOrder, type CreateOrderRequest } from "../api/api";
import type { ErrorMessage } from "../types/types";

export type UseCreateOrderReturn = {
  isSuccess: boolean;
  isError: boolean;
  loading: boolean;
  error: ErrorMessage | null;
  mutateAsync: UseMutateAsyncFunction<void, ErrorMessage, CreateOrderRequest, unknown>;
};

export const useCreateOrder = ({
  onError,
  onSuccess,
  onSettled,
}: {
  onSettled?:
    | ((
        data: void | undefined,
        error: ErrorMessage | null,
        variables: CreateOrderRequest,
        onMutateResult: unknown,
        context: MutationFunctionContext,
      ) => Promise<unknown> | unknown)
    | undefined;
  onError?:
    | ((
        error: ErrorMessage,
        variables: CreateOrderRequest,
        onMutateResult: unknown,
        context: MutationFunctionContext,
      ) => Promise<unknown> | unknown)
    | undefined;
  onSuccess?:
    | ((
        data: void,
        variables: CreateOrderRequest,
        onMutateResult: unknown,
        context: MutationFunctionContext,
      ) => Promise<unknown> | unknown)
    | undefined;
}): UseCreateOrderReturn => {
  const { isPending, isSuccess, isError, error, mutateAsync } = useMutation<void, ErrorMessage, CreateOrderRequest>({
    mutationFn: (body: CreateOrderRequest) => createOrder(body),
    onError: onError,
    onSuccess: onSuccess,
    onSettled: onSettled,
  });

  return {
    loading: isPending,
    isSuccess,
    isError,
    mutateAsync,
    error,
  };
};
export default useCreateOrder;
